import { FC, MouseEventHandler } from 'react'
import { Checkbox } from '@components-v2/atoms/Checkbox'
import styles from './index.module.scss'

type Props = {
  item: {
    id: string
    name: string
  }

  isSelected?: boolean
  isDisabled?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
  labelHtmlFor: string
}

export const SelectOptionItem: FC<Props> = ({
  item,
  isSelected = false,
  isDisabled = false,
  onClick,
  labelHtmlFor,
}) => {
  return (
    <div className={styles.container}>
      <label className={styles.content} htmlFor={labelHtmlFor}>
        <div className={styles.left}>
          <Checkbox selected={isSelected} disabled={isDisabled} onClick={onClick} labelHtmlFor={labelHtmlFor} />
        </div>
        <div className={styles.right}>{item.name}</div>
      </label>
    </div>
  )
}
